module.exports = __webpack_public_path__ + "img/logo.217be327.png";